import { HTMLAttributes, ReactNode, forwardRef } from 'react';

import { Theme, WithStyles, createStyles, withStyles } from '@material-ui/core';

import classNames from 'classnames';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(1),
    },
  });

export interface ContentProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'classes'>,
    WithStyles<typeof styles> {
  children: ReactNode;
}

const Content = forwardRef<HTMLDivElement, ContentProps>((props, ref) => {
  const { className, classes, children, ...rest } = props;

  return (
    <div ref={ref} className={classNames(classes.root, className)} {...rest}>
      {children}
    </div>
  );
});

Content.displayName = 'ActivityFeedItem.Content';

export default withStyles(styles)(Content);
